import { useEffect, useState } from "react";
import { api, fmtTime } from "@/lib/api";
import { Input } from "@/components/ui/input";

const LABEL = {
  login: "Login", login_ditolak_ip: "Login ditolak (IP)", ubah_nama_slot: "Ubah nama slot", kirim_sms: "Kirim SMS",
  kirim_ussd: "Kirim USSD", cek_pulsa: "Cek pulsa", sim_berganti: "SIM berganti", buat_akun: "Buat akun",
  ubah_akun: "Ubah akun", hapus_akun: "Hapus akun", ubah_pengaturan: "Ubah pengaturan", tambah_device: "Tambah device",
  ubah_device: "Ubah device", hapus_device: "Hapus device", sambungkan_device: "Sambungkan device",
  hapus_data_demo: "Hapus data demo", ganti_password: "Ganti kata sandi",
};

export default function Activity() {
  const [list, setList] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/activity").then((r) => setList(r.data)); }, []);
  const shown = list.filter((a) => !q || `${a.user} ${a.action} ${a.detail}`.toLowerCase().includes(q.toLowerCase()));
  return (
    <div className="max-w-4xl space-y-5">
      <div className="flex flex-wrap items-end gap-3">
        <div>
          <p className="text-xs uppercase tracking-wider text-slate-500">Audit</p>
          <h1 className="font-display text-4xl font-bold">Riwayat aktivitas</h1>
        </div>
        <Input data-testid="activity-search" placeholder="Cari…" value={q} onChange={(e) => setQ(e.target.value)} className="ml-auto w-56 bg-white" />
      </div>
      <div className="rounded-lg border border-slate-200 bg-white divide-y divide-slate-200" data-testid="activity-list">
        {shown.map((a) => (
          <div key={a.id} className="grid grid-cols-[100px_1fr] md:grid-cols-[130px_110px_160px_1fr] gap-x-4 gap-y-1 px-4 py-2.5 text-sm">
            <span className="font-mono text-xs text-slate-500">{fmtTime(a.created_at)}</span>
            <span className="font-semibold text-emerald-600">{a.user}</span>
            <span className="text-slate-700">{LABEL[a.action] || a.action}</span>
            <span className="text-slate-500 font-mono text-xs break-all col-span-2 md:col-span-1">{a.detail}</span>
          </div>
        ))}
        {!shown.length && <div className="p-8 text-center text-sm text-slate-500">Belum ada aktivitas.</div>}
      </div>
    </div>
  );
}
